/**
 * Bedrijfsgegevens Service - API calls voor bedrijfsgegevens
 */

import apiFetch from './api';

export interface Bedrijfsgegevens {
  id: number;
  bedrijfsnaam: string;
  bedrijfsnaam_regel1?: string;
  bedrijfsnaam_regel2?: string;
  eigenaar_voornaam?: string;
  eigenaar_achternaam?: string;
  straat?: string;
  huisnummer?: string;
  postcode?: string;
  plaats?: string;
  land: string;
  telefoon?: string;
  mobiel?: string;
  email?: string;
  website?: string;
  kvk_nummer?: string;
  btw_nummer?: string;
  iban?: string;
  banknaam?: string;
  logo_pad?: string;
  factuur_footer?: string;
  algemene_voorwaarden?: string;
  uurloon_inkoop: number;
  uurloon_verkoop: number;
  
  // Nummering instellingen - Werkorders
  werkorder_prefix: string;
  werkorder_gebruik_jaar: boolean;
  werkorder_jaar_formaat: string;
  werkorder_volgnummer_lengte: number;
  werkorder_volgnummer_start: number;
  werkorder_scheiding: string;
  
  // Nummering instellingen - Verkoop Facturen
  factuur_prefix: string;
  factuur_gebruik_jaar: boolean;
  factuur_jaar_formaat: string;
  factuur_volgnummer_lengte: number;
  factuur_volgnummer_start: number;
  factuur_scheiding: string;
  
  // Nummering instellingen - Offertes
  offerte_prefix: string;
  offerte_gebruik_jaar: boolean;
  offerte_jaar_formaat: string;
  offerte_volgnummer_lengte: number;
  offerte_volgnummer_start: number;
  offerte_scheiding: string;
  
  // Nummering instellingen - Inkoop Facturen
  inkoop_prefix: string;
  inkoop_gebruik_jaar: boolean;
  inkoop_jaar_formaat: string;
  inkoop_volgnummer_lengte: number;
  inkoop_volgnummer_start: number;
  inkoop_scheiding: string;
  
  smtp_host?: string;
  smtp_port?: number;
  smtp_user?: string;
  smtp_password?: string;
  smtp_from_email?: string;
  smtp_from_name?: string;
  smtp_use_tls?: boolean;
  
  
  created_at: string;
  updated_at?: string;
}

export interface BedrijfsgegevensUpdate {
  bedrijfsnaam?: string;
  bedrijfsnaam_regel1?: string;
  bedrijfsnaam_regel2?: string;
  eigenaar_voornaam?: string;
  eigenaar_achternaam?: string;
  straat?: string;
  huisnummer?: string;
  postcode?: string;
  plaats?: string;
  land?: string;
  telefoon?: string;
  mobiel?: string;
  email?: string;
  website?: string;
  kvk_nummer?: string;
  btw_nummer?: string;
  iban?: string;
  banknaam?: string;
  logo_pad?: string;
  factuur_footer?: string;
  algemene_voorwaarden?: string;
  uurloon_inkoop?: number;
  uurloon_verkoop?: number;
  
  // Nummering instellingen - Werkorders
  werkorder_prefix?: string;
  werkorder_gebruik_jaar?: boolean;
  werkorder_jaar_formaat?: string;
  werkorder_volgnummer_lengte?: number;
  werkorder_volgnummer_start?: number;
  werkorder_scheiding?: string;
  
  // Nummering instellingen - Verkoop Facturen
  factuur_prefix?: string;
  factuur_gebruik_jaar?: boolean;
  factuur_jaar_formaat?: string;
  factuur_volgnummer_lengte?: number;
  factuur_volgnummer_start?: number;
  factuur_scheiding?: string;
  
  // Nummering instellingen - Offertes
  offerte_prefix?: string;
  offerte_gebruik_jaar?: boolean;
  offerte_jaar_formaat?: string;
  offerte_volgnummer_lengte?: number;
  offerte_volgnummer_start?: number;
  offerte_scheiding?: string;
  
  // Nummering instellingen - Inkoop Facturen
  inkoop_prefix?: string;
  inkoop_gebruik_jaar?: boolean;
  inkoop_jaar_formaat?: string;
  inkoop_volgnummer_lengte?: number;
  inkoop_volgnummer_start?: number;
  inkoop_scheiding?: string;
  
  smtp_host?: string;
  smtp_port?: number;
  smtp_user?: string;
  smtp_password?: string;
  smtp_from_email?: string;
  smtp_from_name?: string;
  smtp_use_tls?: boolean;
  
}

export const bedrijfsgegevensService = {
  async get(): Promise<Bedrijfsgegevens> {
    return apiFetch('/api/v1/bedrijfsgegevens');
  },

  async update(data: BedrijfsgegevensUpdate): Promise<Bedrijfsgegevens> {
    return apiFetch('/api/v1/bedrijfsgegevens', {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },
};
